// extracted by mini-css-extract-plugin
export default {"pageHeader":"page_pageHeader__HMaRd","intro":"page_intro__J6IPM"};